var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-switch',{attrs:{"disabled":_vm.disabled,"active-value":1,"inactive-value":0,"active-color":"#13ce66"},on:{"change":function($event){return _vm.changeStatus($event)}},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})
}
var staticRenderFns = []

export { render, staticRenderFns }